<template>
    <div class="waba-supsis-message-template-components-update">
        <div class="title">{{ $t("auto.whatsappBusinessApiV2MessageTemplateComponentsUpdated") }}</div>
        <div class="meta">
            <div><b>{{ $t("auto.event") }}</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>{{ $t("auto.channelId") }}</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>{{ $t("auto.templateName") }}</b>: {{ $_.get(activity, "payload.message_template_name") }}</div>
            <div><b>{{ $t("auto.templateId") }}</b>: {{ $_.get(activity, "payload.message_template_id") }}</div>
            <div><b>{{ $t("auto.language") }}</b>: {{ $_.get(activity, "payload.message_template_language") }}</div>
            <div v-if="$_.get(activity, 'payload.message_template_title')">
                <b>{{ $t("auto.title") }}</b>: {{ $_.get(activity, "payload.message_template_title") }}
            </div>
            <div v-if="$_.get(activity, 'payload.message_template_element')">
                <b>{{ $t("auto.content") }}</b>: {{ $_.get(activity, "payload.message_template_element") }}
            </div>
            <div v-if="$_.get(activity, 'payload.message_template_footer')">
                <b>{{ $t("auto.footer") }}</b>: {{ $_.get(activity, "payload.message_template_footer") }}
            </div>
            <div v-if="templateButtons.length > 0">
                <b>{{ $t("auto.buttons") }}</b>:
                <ul class="buttons-list">
                    <li v-for="(btn, idx) in templateButtons" :key="idx">
                        {{ btn.message_template_button_text }} ({{ btn.message_template_button_type }})
                    </li>
                </ul>
            </div>
        </div>
        <details class="raw">
            <summary>{{ $t("auto.rawPayload") }}</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisMessageTemplateComponentsUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
        templateButtons() {
            return this.$_.get(this.activity, "payload.message_template_buttons", []);
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-message-template-components-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .buttons-list {
        margin: 4px 0 0 16px;
        padding: 0;
        li {
            margin: 2px 0;
        }
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
